import type { HeroHeaderView } from "@opensea/navigation"
import { classNames, Media, SkeletonBlock } from "@opensea/ui-kit"
import type React from "react"
import { HeroHeaderLayout } from "./HeroHeaderLayout"

type Props = {
  headerView: HeroHeaderView
  fullContent: React.ReactNode
  compactContent: React.ReactNode
  isCollectionBanner?: boolean
}

function HeroHeaderSkeletonBase({
  headerView,
  fullContent,
  compactContent,
  isCollectionBanner = false,
}: Props) {
  return (
    <div className="bg-bg-app">
      <HeroHeaderLayout
        backgroundChildren={
          headerView === "full" && (
            <div className="invisible fixed top-sm-top-nav z-20 lg:visible lg:top-lg-top-nav lg:right-scroll-bar-size lg:left-side-nav">
              {compactContent}
            </div>
          )
        }
        headerView={headerView}
        headerViewScrollLocked={headerView === "compact"}
        isCollectionBanner={isCollectionBanner}
        media={
          headerView === "full" && (
            <SkeletonBlock className="absolute inset-0 size-full bg-bg-additional-1" />
          )
        }
        mediaClassName={classNames(headerView === "full" && "bg-bg-app")}
      >
        {headerView === "full" ? fullContent : compactContent}
      </HeroHeaderLayout>
    </div>
  )
}

export function HeroHeaderSkeleton(props: Props) {
  return (
    <>
      <Media greaterThanOrEqual="lg">
        <HeroHeaderSkeletonBase {...props} />
      </Media>
      <Media lessThan="lg">
        <HeroHeaderSkeletonBase {...props} headerView="full" />
      </Media>
    </>
  )
}
